import { render, staticRenderFns } from "./CoverageTemplate.vue?vue&type=template&id=4cd243e6"
import script from "./CoverageTemplate.vue?vue&type=script&lang=js"
export * from "./CoverageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports